var Filter = {
    changes : [],

    filterWrapper(){
        return $('#js_ProductFilter');
    },
    productsWrapper(){
        return $('#js_ProductWrapper');
    },
    inputs(){
        return this.filterWrapper()
                   .find('.js-filter')
                   .add($('[data-product-search]'));
    },
    buildQuery(){
        var obj = {};

        this.inputs().each(function(){
            var input = $(this),
                name = input.attr('name'),
                value

            if ( input.is(':checkbox') ) {
                value = input.attr('value');

                if ( input.is(':checked') ) {
                    if ( !(name in obj) ){
                        obj[name] = [];
                    }

                    obj[name].push(value);
                }
            } else {
                value = input.val();

                if ( Filter.changes.indexOf(name) > -1 ){
                    obj[name] = value;
                }
            }
        });

        return obj;
    },
    serializeQuery(){
        var obj = this.buildQuery(),
            serialize = [];

        for ( var key in obj ){
            let value = obj[key];

            if ( typeof value == 'object' ) {
                value = value.join(',');
            }

            serialize.push(key+'='+value);
        }

        return serialize.join('&');
    },
    pushState(url){
        url = this.filterWrapper().attr('data-root')+'?'+url;

        history.pushState({}, null, url);
    },
    pushPaginatorQuery(){
        var url = (location.search||'').substr(1);

        url = url.split('&').filter(item => {
            return item.substr(0, 4) != 'page';
        }).join('&');

        $('.pagination a').each(function(){
            if ( ! this.defaultHref ) {
                this.defaultHref = this.href;
            }

            this.href = this.defaultHref+'&'+url+'#productResult';
        });

        $('#resetFilter').removeClass('disabled');
    },
    fillFromUrl(){
        Filter.pushPaginatorQuery();

        var params = location.search.substr(1).split('&').filter(item => item);

        for ( var k in params ) {
            var parts = params[k].split('='),
                name = parts[0],
                values = parts[1].split(','),
                input = this.filterWrapper().find('[name="'+name+'"]'),
                slider;

            //Skip parameter if field does not exists
            if ( input.length == 0 ){
                continue;
            }


            //Checkbox
            if ( input.eq(0).is(':checkbox') ){
                for ( var i = 0; i < values.length; i++ ){
                    this.filterWrapper().find('[name="'+name+'"][value="'+values[i]+'"]')
                                        .attr('checked', true);
                }
            }

            //Ion slider
            else if ( slider = input.data("ionRangeSlider") ){
                priceParts = parts[1].split(';');

                slider.update({
                    from : priceParts[0],
                    to : priceParts[1],
                })
            }

            else {
                input.val(parts[1]).change();
            }
        }
    },

    listenChanges(){
        var timeout,
            onChange = function(callback){
                Filter.changes.push($(this).attr('name'));

                if ( timeout ){
                    clearTimeout(timeout);
                }

                timeout = setTimeout(() => {
                    var serialized = Filter.serializeQuery();

                    Filter.pushState(serialized);

                    Filter.makeAjax(callback);
                }, 300);
            };

        //We want listen for changes maximalny one time per 300ms
        this.inputs().change(onChange);

        $('[data-product-search]').keyup(onChange);

        $('#resetFilter').click(function(){
            Filter.changes = [];

            Filter.inputs().each(function(){
                $(this)[0].checked = false;
            });

            onChange(() => {
                $(this).addClass('disabled');
            });
        })
    },

    makeAjax(callback){
        $('.searchInput').addClass('loading');
        $.post('', response => {
            this.productsWrapper().html(response);

            $('.searchInput').removeClass('loading');

            Filter.pushPaginatorQuery();

            if ( typeof callback == 'function' ) {
                callback();
            }
        })
    },
}

$(() => {
    //Disable filder functions
    if ( Filter.filterWrapper().length == 0 ){
        return;
    }

    Filter.fillFromUrl();

    Filter.listenChanges();
})